import * as Yup from "yup";
import { TFunction } from "i18next";

export const objectShape = (t: TFunction) => ({
  rateType: Yup.string(),
  delayForRedeem: Yup.number()
    .typeError(t("payfac.pageRatePlanModalRequiredField"))
    .required(t("payfac.pageRatePlanModalRequiredField")),
  value: Yup.number()
    .typeError(t("payfac.pageRatePlanModalRequiredField"))
    .required(t("payfac.pageRatePlanModalRequiredField")),
  valueLimit: Yup.number()
    .transform((value, originalValue) =>
      String(originalValue).trim() === "" ? null : value,
    )
    .nullable()
    .when("rateType", {
      is: "PERCENTAGE",
      then: (schema) =>
        schema
          .typeError(t("payfac.pageRatePlanModalRequiredField"))
          .required(t("payfac.pageRatePlanModalRequiredField")),
      otherwise: (schema) => schema.notRequired(),
    }),
});
